export const GET_POLICIES_API_REQUEST = 'GET_POLICIES_API_REQUEST';
export const GET_POLICIES_API_ERROR = 'GET_POLICIES_API_ERROR';
export const GET_POLICIES_API_SUCCESS = 'GET_POLICIES_API_SUCCESS';
